export default "__VITE_ASSET__88ca8e09__"